import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaUsers} from "react-icons/fa";

function HousekeepingManpower(){

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "The Helper Ji housekeeping staff understood our routine in a few days. We don’t have to keep repeating instructions anymore.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Work is completed on time, and behavior is respectful. HelperJi's manpower has been reliable so far.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "Earlier, helpers used to change frequently. Since Helper Ji provided housekeeping manpower, attendance has been stable.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

  const services = [
      {
        name: "Housekeeping Manpower Services Delhi",
        link: "/housekeeping-manpower-services-delhi",
        icon: <FaUsers />
      },
      {
        name: "Housekeeping Manpower Services Ghaziabad",
        link: "/housekeeping-manpower-services-ghaziabad",
        icon: <FaUsers />
      },
      {
        name: "Housekeeping Manpower Services Noida",
        link: "/housekeeping-manpower-services-noida",
        icon: <FaUsers />
      }
    ];

    return(
        <Fragment>
          <Helmet>
             {/* BASIC META */}
    <title>
      Housekeeping Manpower Company in Gurugram | Corporate Manpower Services
    </title>
    <meta
      name="description"
      content="Hire professional housekeeping manpower services in Gurugram offering corporate housekeeping services, trained staff & reliable support from trusted manpower company for corporate."
    />
    <meta
      name="keywords"
      content="Housekeeping Manpower Services In Gurugram, Corporate Housekeeping Services In Gurugram, Housekeeping Services For Corporates In Gurugram, Housekeeping Company In Gurugram, Housekeeping Manpower Agency In Gurugram, Professional Housekeeping Manpower Services, Housekeeping Services"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://www.helperji.in/housekeeping-manpower-services-gurugram"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Housekeeping Manpower Company in Gurugram | Corporate Manpower Services"
    />
    <meta
      property="og:description"
      content="Hire professional housekeeping manpower services in Gurugram offering corporate housekeeping services, trained staff & reliable support from trusted manpower company for corporate."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/housekeeping1.png"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta
      property="og:url"
      content="https://www.helperji.in/housekeeping-manpower-services-gurugram"
    />
    <meta property="og:type" content="website" />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Housekeeping Manpower Company in Gurugram | Corporate Manpower Services"
    />
    <meta
      name="twitter:description"
      content="Hire professional housekeeping manpower services in Gurugram offering corporate housekeeping services, trained staff & reliable support from trusted manpower company for corporate."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/housekeeping1.png"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/housekeeping-manpower-services-gurugram",
        "name": "Housekeeping Manpower Company in Gurugram | Corporate Manpower Services",
        "description": "Hire professional housekeeping manpower services in Gurugram offering corporate housekeeping services, trained staff & reliable support from trusted manpower company for corporate."
      }
      `}
    </script>

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Housekeeping Manpower Services in Gurugram",
        "image": "https://www.helperji.in/assets/img/housekeeping1.png",
        "description": "Hire professional housekeeping manpower services in Gurugram offering corporate housekeeping services, trained staff & reliable support from trusted manpower company for corporate.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "548"
        }
      }
      `}
    </script>

    {/* BREADCRUMB SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Housekeeping Manpower Services",
            "item": "https://www.helperji.in/housekeeping-manpower-services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Housekeeping Manpower Services in Gurugram",
            "item": "https://www.helperji.in/housekeeping-manpower-services-gurugram"
          }
        ]
      }
      `}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What are housekeeping services for corporates in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Housekeeping services for corporates in Gurgaon include trained manpower for cleaning offices, maintaining hygiene, and managing daily housekeeping tasks."
            }
          },
          {
            "@type": "Question",
            "name": "Is Helper Ji a housekeeping manpower agency near me in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji is a reliable housekeeping manpower agency in Gurgaon supplying trained and supervised housekeeping staff."
            }
          },
          {
            "@type": "Question",
            "name": "What housekeeping manpower services do you offer in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our housekeeping manpower services in Gurgaon include floor cleaning, dusting, sanitizing, restroom cleaning, pantry maintenance, garbage management, and glass cleaning."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide customised corporate housekeeping services in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer customised corporate housekeeping services in Gurgaon based on office size and cleaning frequency."
            }
          },
          {
            "@type": "Question",
            "name": "Are your staff trained for corporate environments?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, all staff from our housekeeping manpower agency are trained to meet corporate hygiene and safety standards."
            }
          }
        ]
      }
      `}
    </script>
      <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
          </Helmet>
            
            <Floatingcall />
         
            <section id="about" class="about">
            <div class="container" data-aos="fade-up">

            <div class="section-header">
            <h2>Corporate Housekeeping Services in Gurugram</h2>
            <p>Professional Housekeeping Manpower Agency – Helper Ji</p>
             </div>

           <div class="row gy-4">
           <div class="col-lg-6">
            <img src="/assets/img/housekeeping1.png" class="img-fluid rounded-4 mb-4" alt="" />
            
            </div>
          
          <div class="col-lg-6">
            <div class="content ps-0 ps-lg-5">
             <p className="text-justify">Helper Ji offers professional housekeeping services for corporates in Gurugram, supplying trained and dependable staff for offices and business centres. As a recognised housekeeping manpower agency near me, we focus on structured cleaning and manpower reliability.</p>
              <p className="text-justify">Our housekeeping manpower services in Gurugram are designed to maintain cleanliness, hygiene, and workplace discipline in corporate settings..</p>
              <h4>Our Housekeeping Manpower Services in Gurugram Include:</h4>
              <ul>
                  <li><i class="bi bi-check-circle-fill"></i>Floor cleaning and maintenance.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Dusting and sanitising of work areas.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Restroom cleaning and hygiene management.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Pantry and kitchen area cleaning.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Garbage collection and disposal.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Furniture and upholstery cleaning.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Glass and window cleaning.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Specialised cleaning for corporate zones.</li>
                </ul>

                 <h4 className="pt-3">Why Choose Helper Ji in Gurugram?</h4>
              <ul>
                  <li><i class="bi bi-check-circle-fill"></i>Experienced housekeeping manpower agency.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Corporate-focused cleaning approach.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Affordable housekeeping services for corporates.</li>
                  <li><i class="bi bi-check-circle-fill"></i>Compliance with safety and labour regulations.</li>
                </ul>
                
            </div>
          </div>
        </div>

      </div>
    </section>


    

      <section className="py-5 bg-light">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

        

        <section id="services" class="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            FAQs – Corporate Housekeeping Services in Gurugram
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                 What are housekeeping services for corporates in Gurugram?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Housekeeping services for corporates in Gurugram include trained manpower for cleaning offices, maintaining hygiene, and managing daily housekeeping tasks.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Is Helper Ji a housekeeping manpower agency near me in Gurugram?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, Helper Ji is a reliable housekeeping manpower agency near me in Gurugram, supplying trained and supervised housekeeping staff.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  What housekeeping manpower services do you offer in Gurugram?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our housekeeping manpower services in Gurugram include floor cleaning, dusting, sanitizing, restroom cleaning, pantry maintenance, garbage management, and glass cleaning.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Do you provide customised corporate housekeeping services in Gurugram?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, we offer customised corporate housekeeping services in Gurugram based on office size and cleaning frequency.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Are your staff trained for corporate environments?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, all staff from our housekeeping manpower agency are trained to meet corporate hygiene and safety standards.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LandingPageClient />

         <section className="py-5 sections-bg">
                            <div className="container">
                              <div className="row mb-4">
                                <div className="col text-center">
                                  <h2 className="fw-bold">Other Locations</h2>
                                  <p className="text-muted">
                                    Explore our other locations of Housekeeping Manpower
                                    Services
                                  </p>
                                </div>
                              </div>
                      
                              <div className="row g-4">
                                {services.map((service, index) => (
                                  <div className="col-md-4 col-sm-6" key={index}>
                                    <Link
                                      to={service.link}
                                      className="text-decoration-none text-dark"
                                    >
                                      <div className="card h-100 shadow-sm border-0 service-card">
                                        <div className="card-body d-flex align-items-center">
                                          <div className="service-icon me-3">
                                            {service.icon}
                                          </div>
                                          <h6 className="mb-0 fw-semibold">
                                            {service.name}
                                          </h6>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </section>

        </Fragment>
    )
}

export default HousekeepingManpower;